import { errorThatWillCauseAlert } from 'owa-trace';

export function alertWorkerLoggingError(error: unknown): void {
    errorThatWillCauseAlert(
        'AnalyticsWorkers_MainThread_EventFailedInWebWorker',
        normalizeWorkerLoggingError(error)
    );
}

export function normalizeWorkerLoggingError(error: unknown): Error {
    return error instanceof Error
        ? error
        : Object.assign(new Error('Unknown analytics worker logging error'), { cause: error });
}
